package com.appcreator.client.firebase.auth

import coil3.PlatformContext

internal actual suspend fun platformLogout(context: PlatformContext) {
}